// Formats a fulfillment timestamp (pickedUpAt / deliveredAt) as "Oct 28, 2026 · 3:45 PM" in the user's local timezone.
// Returns '' when the timestamp is missing or invalid so callers can fall back to status only.
export function formatFulfillmentTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  // Normalise the narrow no-break space some ICU builds put before AM/PM
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }).replace(/ /g, ' ');
  return `${day} · ${time}`;
}
